module.exports = __webpack_public_path__ + "img/sound-decision-maker.359f5302.svg";